// emailCheck 邮箱校验
// 返回值 0为空 1为正确 2为错误
function emailCheck(text) {
    let emailreg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
    if(!text || text.length == 0) {
        return 0;
    }
    if(!emailreg.test(text)) {
        return 2;
    }
    return 1;
}
export {
    emailCheck
}


// WEBPACK FOOTER //
// ./src/util/emailCheck.js